import React from "react";
import Title from "../../components/title/Title";
import Card from "./Card";

const Contact = () => {
  return (
    <section
      id="contact"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="CONTACT"
          desc="Contact With Me"
          fontSize="text-3xl md:text-5xl"
          styles="text-center"
        />
      </div>
      <div className="w-full">
        <div className="grid lg:grid-cols-3 gap-10">
          <Card />
          <div className="w-full h-full py-10 lg:col-span-2 bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lg:p-8 rounded-lg shadow-shadowOne">
            <form
              action="https://getform.io/f/6fcc058c-d59d-42eb-b299-94da124d9ab4"
              method="POST"
            >
              <div className="grid md:grid-cols-2 mb-5">
                <div className="space-y-2 md:mr-6 mb-5 md:mb-0">
                  <label
                    htmlFor=""
                    className="text-sm text-gray-400 uppercase tracking-wide"
                  >
                    YOUR NAME
                  </label>
                  <input type="text" name="name" className="contactInput" />
                </div>
                <div className="space-y-2">
                  <label
                    htmlFor=""
                    className="text-sm text-gray-400 uppercase tracking-wide"
                  >
                    PHONE NUMBER
                  </label>
                  <input type="tel" name="phone" className="contactInput" />
                </div>
              </div>
              <div className="col-span-2 space-y-2 mb-5">
                <label
                  htmlFor=""
                  className="text-sm text-gray-400 uppercase tracking-wide"
                >
                  EMAIL
                </label>
                <input type="email" name="email" className="contactInput" />
              </div>
              <div className="col-span-2 space-y-2 mb-5">
                <label
                  htmlFor=""
                  className="text-sm text-gray-400 uppercase tracking-wide"
                >
                  SUBJECT
                </label>
                <input type="text" className="contactInput" />
              </div>
              <div className="col-span-2 space-y-2 mb-5">
                <label
                  htmlFor=""
                  className="text-sm text-gray-400 uppercase tracking-wide"
                >
                  message
                </label>
                <textarea
                  className="contactTextArea"
                  name="message"
                  cols="30"
                  rows="8"
                ></textarea>
              </div>
              <div className="w-full">
                <button type="submit" className="btn w-full">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
